import { Component, inject, OnInit, signal } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { PublicControllerService } from 'src/app/api-client';

@Component({
  selector: 'app-terms-of-service',
  templateUrl: './terms-of-service.component.html',
  styleUrls: ['./terms-of-service.component.scss'],
})
export class TermsOfServiceComponent implements OnInit {
  private _public = inject(PublicControllerService);

  public terms = signal<any>(null);

  constructor(private sanitized: DomSanitizer) {}

  ngOnInit(): void {
    this.getTermsOfService();
  }

  private getTermsOfService() {
    this._public.getUserAgreementForWeb().subscribe({
      next: (value) => {
        let formattedString = value
          .replaceAll('\\n', ' ')
          .replaceAll('<hr>', ' ');
        this.terms.update(() =>
          this.sanitized.bypassSecurityTrustHtml(formattedString)
        );
      },
    });
  }
}
